/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();

$(document).ready(function() {
  
  // Back top TOp
  $("#back-to-top").click(function() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });

  // Show/hide the "Back to Top" arrow based on scroll position
  $(window).scroll(function() {
    if ($(this).scrollTop() > 100) {
      $("#back-to-top").css("display", "flex");
    } else {
      $("#back-to-top").fadeOut();
    }
  });

  $(".product__video-wrapper").prev().addClass('video-custom-thumb');
  // Get a reference to the button element by its ID
  var buttons = document.getElementsByClassName("video-custom-thumb");

  for (var i = 0; i < buttons.length; i++) {
    console.log(buttons[i]);
    buttons[i].addEventListener("click", function(index) {
      return function() {
        var video = document.querySelector('.product__video');
        if (video) {
          var videoType = video.getAttribute('data-video-type');
          var videoId = video.id;
          if (videoType === 'youtube') {
            if (buttons[index].classList.contains("videoPlayed")) {
              __videoObject[videoId].videoPlayer.pauseVideo();
              buttons[index].classList.remove("videoPlayed");
            }else{
              __videoObject[videoId].videoPlayer.playVideo();
              buttons[index].classList.add("videoPlayed");
            }
            return;
          }
        }
      };
    }(i)); // Pass the current value of i as a parameter to the closure
  }
  $('.post-comment-title').click(function() {
    if($(this).parents('#comments').hasClass('active')) {
      $(this).parents('#comments').removeClass('active');
      $('.post-comment-form').slideDown();
    }
    else {
      $(this).parents('#comments').addClass('active');
      $('.post-comment-form').slideUp();
    }
  });
  $('.featured_sticky .section-header').click(function() {
    if($('.featured_sticky').hasClass('active')) {
      $('.featured_sticky').removeClass('active');
      $('.featured-collection-main').slideUp();
    }
    else {
      $('.featured_sticky').addClass('active');
      $('.featured-collection-main').slideDown();
    }
  });
  $('.video-cover-img').click(function() {
    $(this).addClass('hide');
    var url = $(this).attr('data-url');
    $(this).parent().find('iframe').attr('src', url);
  })
});



 
